import { filter, ignoreElements, tap } from 'rxjs/operators';

import { formatName } from '../../../general/utils/formatters';
import { Services } from '../../../services';
import { RootState } from '../../../store';
import { RootEpic } from '../../../store/epics';
import { selectPersonalInfo } from '../../application/reducers/personalInfo';
import { loadAnalyticsDataSuccess } from '../reducers/analytics-data';

type GrowsumoData = {
  partner_key?: string;
  name: string;
  email: string;
  customer_key?: string;
};

export type PartnerStackWindow = {
  growsumo?: {
    data: GrowsumoData;
    createSignup(): void;
  };
} & Window;

const createSignupEpic: RootEpic = (action$, state$, { window }: Services) =>
  action$.pipe(
    filter(loadAnalyticsDataSuccess.match),
    tap(({ payload: { userId } }) => signUp(window, state$.value, userId)),
    ignoreElements(),
  );

const signUp = (window: PartnerStackWindow, state: RootState, userId: string) => {
  const data = window.growsumo?.data;
  const env = window.location.hostname;
  if (data?.partner_key && env !== 'localhost') {
    const { firstName, lastName } = selectPersonalInfo(state);
    const { email } = state.preliminaryInfo.info;

    data.name = formatName(lastName, firstName) || email;
    data.email = email;
    data.customer_key = userId;

    window.growsumo?.createSignup();
  }
};

export { createSignupEpic };
